// Third Party
import React from 'react';
import classNames from 'classnames';

// Components
import Button, { ButtonProps } from './Button';

const TertiaryButton = ({ className, children, ...rest }: ButtonProps) => (
  <Button className={classNames(className, 'tertiary')} {...rest}>
    {children}
  </Button>
);

export default TertiaryButton;
